// === DEFAULT / CUSTOM STYLE ===
// WARNING! always comment out ONE of the two require() calls below.
// 1. use next line to activate CUSTOM STYLE (./src/themes)
require(`./themes/app.${__THEME}.styl`)
// 2. or, use next line to activate DEFAULT QUASAR STYLE
// require(`quasar/dist/quasar.${__THEME}.css`)
// ==============================

// Uncomment the following lines if you need IE11/Edge support
require(`quasar/dist/quasar.ie`)
require(`quasar/dist/quasar.ie.${__THEME}.css`)

import Vue from 'vue'
import Quasar, { Platform } from 'quasar'
import router from './router'
import Vuelidate from 'vuelidate'
import { showAlert, hideAlert } from './js/alerts.js'
import i18n from './js/i18n.js';
import ads from './js/ads.js';
import VTooltip from 'v-tooltip';

Vue.config.productionTip = false
Vue.use(Quasar)
Vue.use(Vuelidate)
Vue.use(i18n.VuePlugin)
Vue.use(VTooltip, {
  disposeTimeout: 0,
  autoHide: false,
  defaultDelay: { show: 500, hide: 0 }
})

/*
if (__THEME === 'mat') {
  require('quasar-extras/roboto-font')
}
*/
import 'quasar-extras/material-icons'
// import 'quasar-extras/ionicons'
// import 'quasar-extras/fontawesome'
// import 'quasar-extras/animate'

// import './virkey-cloud-gopherjs'

// Added fastclick (only needed on iOS)
import * as FastClick from 'fastclick';
document.addEventListener('DOMContentLoaded', () => {
  FastClick.attach(document.body)
}, false)

var showCookieConsent = false;

router.afterEach(function (toRoute, fromRoute) {
  console.log("router.afterEach: toRoute.name=", toRoute.name, ", fromRoute.name=", fromRoute.name);
  changeAdVisibility();

  // Re-enable open with universal links (was disabled when reading NFC label in LockEdit.vue)
  window.psgo.publish({
    to: "app.links.shot.enable",
    dat: { val: true }
  });
});

function showLoginIfUnauthenticated(status) {
  console.log("showLoginIfUnauthenticated: status=", status, ", router.currentRoute=", router.currentRoute, ", showCookieConsent=", showCookieConsent);
  if (showCookieConsent) {
    router.replace("/cookies");
  } else if (status === "ready") {
    console.log("showLoginIfUnauthenticated: to ready");
    router.replace("/");
  } else if (router.currentRoute.path !== "/login" && status !== "unknown") {
    console.log("showLoginIfUnauthenticated: to login");
    router.replace("/login");
  }
}

function backButtonPressed() {
  console.log("backButtonPressed: currentRoute=", router.currentRoute.name);

  switch (router.currentRoute.name) {
    case "locks":
    case "keys":
    case "settings":
    case "manufacturer":
      router.push("/scan");
      break;
    case "login":
    case "scan":
      window.plugins.appMinimize.minimize();
      break;
    default:
      router.go(-1);
  }
}

let status, newVirkey;
window.psgo.subscribeFuncs({
  "app.state.ready": msg => {
    onAppReady(msg)
  },
  "app.navigateBack": msg => {
    console.log("GOT app.navigateBack");
    backButtonPressed()
  },
  "app.session.status": msg => {
    status = msg.dat.val;
    showLoginIfUnauthenticated(msg.dat.val)
  },
  "app.scan.editNewVirkey": msg => {
    newVirkey = msg.dat.val;
    changeAdVisibility();
  },
  "app.alerts.show": msg => {
    processAlert(msg.dat.val);
  },
  "app.cookies.showCookieConsent": msg => {
    console.log('main: app.cookies.showCookieConsent received: msg=', msg);
    showCookieConsent = msg.dat;
    if (msg.dat) {
      router.replace("/cookies");
    }
  }
})

function changeAdVisibility() {
  if (Platform.is.cordova) {
    console.log("changeAdVisibility router.currentRoute.name=", router.currentRoute.name, ", status=", status, ", newVirkey=", newVirkey);
    if (router.currentRoute.name === "scan" &&
      (status === "ready" || status === "unknown") &&
      !newVirkey) {
      ads.showAd();
    } else {
      ads.hideAd();
    }
  }
}

function processAlert(alertCfg) {
  console.log("main.processAlert alertCfg: ", alertCfg);
  if (alertCfg) {
    showAlert(alertCfg);
  } else {
    hideAlert();
  }
}

function onAppReady(msg) {
  console.log("onAppReady JS called");

  // window.navigator.splashscreen.hide();

  document.addEventListener("backbutton", backButtonPressed, false);

  ads.init();

  window.vm = new Vue({
    el: '#q-app',
    router: router,
    render: h => h(require('./App').default),
    data: {
    }
  });

  console.log("vm created");
}

Quasar.start(() => {
  /* eslint-disable no-new */

  console.log("Quasar start");
  console.log("Quasar start Platform.is.cordova:", Platform.is.cordova);

  if (!Platform.is.cordova) {
    var tag = document.createElement('script');
    tag.type = 'text/javascript';
    document.body.appendChild(tag);
    tag.src = 'cordova.js';
  }
})



// WEBPACK FOOTER //
// ./src/main.js